import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {ApiService} from './api.service';
import 'rxjs/add/operator/map';
import * as moment from 'moment';

@Injectable()
export class PatientService {

    constructor(
        private apiService: ApiService
    ) {
    }

    getPatients(): Observable<any> {
        return this.apiService.get('/patient/my');
    }

    getPatientsShortInfo(page, count): Observable<any> {
        return this.apiService.get(`/patient/myShortInfo?page=${page}&count=${count}`);
    }

    getPatient(imei): Observable<any> {
        return this.apiService.get(`/patient/${imei}`);
    }

    getPatientToEdit(imei): Observable<any> {
        return this.apiService.get(`/manager/patient-edit-initial-data/${imei}`);
    }

    getPatientCardToEdit(imei): Observable<any> {
      return this.apiService.get(`/patientCard/${imei}`);
    }

    addPatient(data): Observable<any> {
        return this.apiService.post('/manager/patient', data);
    }

    editPatient(imei, data): Observable<any> {
        return this.apiService.patch(`/manager/patient/${imei}`, data);
    }

    editPatientCard(imei, data): Observable<any> {
      return this.apiService.patch(`/patientCard/create/${imei}`, data);
    }

    deletePatient(id): Observable<any> {
        return this.apiService.delete(`/manager/patient/${id}`);
    }

    getPatientsToAssign(caregiver): Observable<any> {
        return this.apiService.get(`/manager/available-patient-to-assign/${caregiver}`);
    }

    getAlarm(imei, type): Observable<any> {
        return this.apiService.get(`/patient/${imei}/alarm/${type}`);
    }

    getAlarmEBS(imei, type): Observable<any> {
        return this.apiService.get(`/patient/${imei}/alarmEBS/${type}`);
    }

    getDiagramStats(imei, fromDate, toDate): Observable<any> {
        return this.apiService.get(`/patient/${imei}/stats?fromDate=${fromDate}&toDate=${toDate}`);
    }

    getMedicines(imei): Observable<any> {
        return this.apiService.get(`/manager/patient/${imei}/drugs`);
    }

    getMedicine(id): Observable<any> {
        return this.apiService.get(`/manager/patient/drugs/${id}`);
    }

    addMedicine(data): Observable<any> {
        return this.apiService.post('/manager/patient/drug', data);
    }

    editMedicine(id, data): Observable<any> {
        return this.apiService.post(`/manager/patient/drug/${id}`, data);
    }

    deleteMedicine(id): Observable<any> {
        return this.apiService.delete(`/manager/patient/drug/${id}`);
    }

    generateRaport(imei, data): Observable<any> {
        return this.apiService.post(`/patient/report/${imei}`, data);
    }

    generateRaportTMP(data): Observable<any> {
        return this.apiService.post(`/patient/reportTMP/`, data);
    }


    handleNotif(id): Observable<any> {
        return this.apiService.get(`/notification-board2/${id}`);
    }

    handleAllNotif(): Observable<any> {
        return this.apiService.get(`/my-notif-handleall`);
    }

    getNotif(limit): Observable<any> {
        return this.apiService.get(`/my-notif/${limit}`);
    }

    getNewestNotif(newestId): Observable<any> {
        return this.apiService.get(`/my-newest-notif/${newestId}`);
    }

    getForDateNotif(date, limit): Observable<any> {
        return this.apiService.get(`/my-notif-fordate/${date}/${limit}`);
    }

    getForReasonNotif(reason, limit): Observable<any> {
        return this.apiService.get(`/my-notif-forreason/${reason}/${limit}`);
    }

    checkIfNewHandle(): Observable<any> {
        return this.apiService.get(`/my-notif-checkHandle`);
    }

    formContact(mail, phone, reason, type): Observable<any> {
        return this.apiService.get(`/contact/${mail}/${phone}/${reason}/${type}`);
    }

    questionnaireContact(expection, howoften, isok, more): Observable<any> {
        return this.apiService.get(`/questionnaire/${expection}/${howoften}/${isok}/${more}`);
    }

    getUserContact(): Observable<any> {
        return this.apiService.get(`/phoneandmail/`);
    }

    //BEACONS

    getBeacons(): Observable<any> {
        return this.apiService.get(`/get-beacons`);
    }

    getBeaconFromMac(mac): Observable<any> {
        return this.apiService.get(`/getBeacon/mac/${mac}`);
    }

    getBeacon(id): Observable<any> {
        return this.apiService.get(`/get-beacon/${id}`);
    }

    editBeacon(id, mac, name, address, lat, lon): Observable<any> {
        return this.apiService.get(`/edit-beacon/${id}/${mac}/${name}/${address}/${lat}/${lon}`);
    }

    deleteBeacon(id): Observable<any> {
        return this.apiService.delete(`/delete-beacon/${id}`);
    }

    addBeacon(data): Observable<any> {
        return this.apiService.post('/beacon-create', data);
    }

    addBeacon2(mac, name, address, lat, lon): Observable<any> {
        return this.apiService.get(`/create-beacon/${mac}/${name}/${address}/${lat}/${lon}`);
    }


    //EBS

    getEbs(imei): Observable<any> {
        return this.apiService.get(`/get-ebses/${imei}`);
    }

    addEbs(imei, data): Observable<any> {
        return this.apiService.post(`/addSensor/${imei}`, data);
    }

    editEbs(data): Observable<any> {
        return this.apiService.post(`/editSensor`, data);
    }

    deleteEbs(sn): Observable<any> {
        return this.apiService.delete(`/delete-ebs/${sn}`);
    }

    checkSn(sn): Observable<any> {
        return this.apiService.get(`/checkSN/${sn}`);
    }

    //communicate network

    getDiseases(imei): Observable<any> {
        return this.apiService.get(`/getDiseases/${imei}`);
    }

    getContacts(imei): Observable<any> {
        return this.apiService.get(`/getContacts/${imei}`);
    }

    editContacts(imei, data): Observable<any> {
        return this.apiService.patch(`/editContacts/${imei}`, data);
    }

    editDiseases(imei, data): Observable<any> {
        return this.apiService.patch(`/editDiseases/${imei}`, data);
    }

    //CPL
    getNewCPL(id): Observable<any> {
        return this.apiService.get(`/alarm/meas/${id}`);
    }

    //Carehome
    getHours(imei): Observable<any> {
        return this.apiService.get(`/getHours/${imei}`);
    }


    addExtraNoteToAlarm(data): Observable<any> {
        return this.apiService.post('/alarm/addExtraNote', data);
    }

    //documents
    getDocumentFromDocumentation(id): Observable<any> {
        return this.apiService.get(`/getDocumentation/${id}`);
    }


    uploadDocumentToDocumentation(data): Observable<any> {
        return this.apiService.post('/saveDocumentFile', data);
    }


    getDocuments(imei): Observable<any> {
        return this.apiService.get(`/getDocuments/${imei}`);
    }

    getRegulation(): Observable<any> {
      return this.apiService.get(`/getRegulation`);
    }


    //projects

    getProjectsForManager(): Observable<any> {
        return this.apiService.get(`/getProjects`);
    }

    getProject(id): Observable<any> {
        return this.apiService.get(`/getProject/${id}`);
    }

    checkFreeNameOfProject(): Observable<any> {
        return this.apiService.get(`/checkIfNameProjectIsFree`);
    }

    addProject(projectName, interval, sidePanel): Observable<any> {
        return this.apiService.get(`/create-project/${projectName}/${interval}/${sidePanel}`);
    }

    editProject(id, projectName, interval, activeSidePanel): Observable<any> {
        return this.apiService.get(`/edit-project/${id}/${projectName}/${interval}/${activeSidePanel}`);
    }

    deleteProject(id): Observable<any> {
        return this.apiService.delete(`/delete-project/${id}`);
    }

    getUsersWithDeactivePanel(id): Observable<any> {
        return this.apiService.get(`/manager/users-deactivated-panel/${id}`);
    }

    setActiveSidePanelForUser(id): Observable<any> {
        return this.apiService.get(`/manager/set-active-side-panel/${id}`);
    }

    checkIfManagerHasProject(): Observable<any> {
        return this.apiService.get(`/checkIfManagerHasProject`);
    }


    //sidenav

    getSideNav(): Observable<any> {
        return this.apiService.get(`/getSidenavNotifs`);
    }

    startHandleSideNotif(id): Observable<any> {
        return this.apiService.get(`/startHandle/sideNotif/${id}`);
    }

    handleSideNotif(id, note, turnOffSideNotifs): Observable<any> {
        return this.apiService.get(`/handle/sideNotif/${id}?note=${note}&turnOffSideNotifs=${turnOffSideNotifs}`);
    }

    getCityFromZipCode(zipCode): Observable<any> {
      return this.apiService.get(`/patient/zip-code/${zipCode}`);
    }

    //indivClient

    changeStatus(status): Observable<any> {
      return this.apiService.get(`/patient/changeStatusOfUser/${status}`);
    }

    getBandCard(imei): Observable<any> {
      return this.apiService.get(`/getBandCard/${imei}`);
    }

    getPredefinedFields(imei): Observable<any> {
      return this.apiService.get(`/user/getPredefinedField/${imei}`);
    }

    addPredefinedFields(name, description, type): Observable<any> {
      return this.apiService.post(`/user/addPredefinedField`, { name: name, description: description, type: type });
    }

    setPredefinedFields(imei, predefinedField, value): Observable<any> {
      return this.apiService.post(`/user/setPredefinedField/${imei}`, { predefined_field: predefinedField, value: value });
    }

    removePredefinedFields(id): Observable<any> {
      return this.apiService.delete(`/user/removePredefinedField`, { id: id });
    }

    getDistrictList(): Observable<any> {
      return this.apiService.get(`/user/getDistrictList`);
    }

    getCommuneList(): Observable<any> {
      return this.apiService.get(`/user/getCommuneList`);
    }

    getProjectList(): Observable<any> {
      return this.apiService.get(`/user/getProjectList`);
    }

    call(data): Observable<any> {
      return this.apiService.post(`/manager/call`, data);
    }

    getTechnicalAlerts(): Observable<any> {
      return this.apiService.get(`/manager/getTechnicalAlerts`);
    }

    changeAlarmStatus(alarmId, value): Observable<any> {
      return this.apiService.post(`/manager/changeAlarmStatus`, { alarmId: alarmId, value: value });
    }

    getSim(imei): Observable<any> {
      return this.apiService.get(`/manager/getSim/${imei}`);
    }

    setSim(data): Observable<any> {
      return this.apiService.post(`/manager/setSim`, data);
    }

    getAvatar(userId): Observable<any> {
      return this.apiService.get(`/manager/getAvatar/${userId}`);
    }

    getLastLocalization(imei): Observable<any> {
      return this.apiService.get(`/manager/getLastLocalization/${imei}`);
    }

    getBandNote(imei): Observable<any> {
      return this.apiService.get(`/manager/getBandNote/${imei}`);
    }

    setBandNote(imei, note): Observable<any> {
      const timenow = moment().format('YYYY-MM-DD HH:mm:ss');
      return this.apiService.post(`/manager/setBandNote/${imei}`, { note: note, date: timenow });
    }

    getPatientAlarmZones(imei): Observable<any> {
      return this.apiService.get(`/manager/getAlarmZones/${imei}`);
    }

    deleteAlarmZone(id): Observable<any> {
      return this.apiService.delete(`/manager/deleteAlarmZone/${id}`);
    }

    setAlarmZones(imei, alarmZoneForms): Observable<any> {
      return this.apiService.post(`/manager/setAlarmZones/${imei}`, { alarmZoneForms });
    }

    addAlarmZone(imei): Observable<any> {
      return this.apiService.put(`/manager/addAlarmZone`, { imei: imei });
    }

    getUsedPhones(): Observable<any> {
      return this.apiService.get(`/manager/getUsedPhones`);
    }

    refreshLoc(imei): Observable<any> {
      return this.apiService.post(`/manager/refreshLoc`, { imei: imei });
    }

    getListUsersShort(page = -1, count = -1): Observable<any> {
      return this.apiService.get(`/patient/listUsersShort`, { page: page, count: count});
    }

    setCustomIVRSettings(data): Observable<any> {
      return this.apiService.post(`/setCustomIVRSettings`, data);
    }

    // Wristband service status methods
    markWristbandAsInService(imei): Observable<any> {
      return this.apiService.post(`/manager/wristband/mark-service`, { imei: imei });
    }

    unmarkWristbandFromService(imei): Observable<any> {
      return this.apiService.post(`/manager/wristband/unmark-service`, { imei: imei });
    }

    getWristbandServiceStatus(imei): Observable<any> {
      return this.apiService.get(`/manager/wristband/service-status/${imei}`);
    }

    // Device service status methods (4-status system: Serwis=3, Gmina=2, Telecentrum=1, Uczestnik=0)
    setDeviceServiceStatus(imei, serviceStatus): Observable<any> {
      return this.apiService.post(`/patient/service-status/${imei}`, { serviceStatus: serviceStatus });
    }

    getDeviceServiceStatus(imei): Observable<any> {
      return this.apiService.get(`/patient/service-status/${imei}`);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/patient.service.ts